import React, { useEffect, useState, useRef } from "react";
import Detail from "./detail";
import DetailMenu from "./detailMenu";
import $ from "jquery";
const SubMenu = (props) => {
  const { detailPageShown, homeMenuReset, onDetailShown } = props;
  const [selectedItem, setSelectedItem] = useState(null);
  const [expandDetail, setExpandDetail] = useState(false);

  const homeMenuResetHandler = () => {
    if (detailPageShown) {
      onDetailShown(false);
      setSelectedItem(null);
    } else {
      homeMenuReset();
    }
  };
  // JellyScroll("container", {
  //     friction: .5, // recommended .5, sets jelly friction
  //     strength: 100 // recommended 100, sets jelly strenght
  // });

  const subMenuChanged = (item) => {
    if (props.onDetailShown != null && selectedItem == null) {
      props.onDetailShown(true);
    }
    setSelectedItem(item);

    let menuDiv = $("#menuDiv")[0];
    if (menuDiv != null) menuDiv.style.width = "33.3%";

    let dividerDiv = $("#dividerDiv")[0];
    if (dividerDiv != null) dividerDiv.style.width = "66.6%";

    let detailDiv = $("#detailDiv")[0];
    if (detailDiv != null) detailDiv.style.width = "0%";

    setTimeout(() => {
      if (dividerDiv != null) dividerDiv.style.width = "0%";
      if (detailDiv != null) detailDiv.style.width = "66.6%";
    }, 1000);
  };

  useEffect(() => { }, [props]);

  return (
    <div>
      <div className="project-lists project_detail">
        <div
          id="menuDiv"
          style={{
            float: "left",
            width: selectedItem == null ? "100%" : "33.3%",
            height: "100vh",
            overflowY: "auto",
          }}
          className={`trans ${selectedItem == null ? "" : "small_menus"}`}
        >
          <DetailMenu
            links={props.links}
            onChange={subMenuChanged}
            homeMenuReset={homeMenuResetHandler}
          />
        </div>
        <div
          id="dividerDiv"
          style={{
            width: selectedItem != null ? "66.6%" : "0%",
            height: selectedItem != null ? "100vh" : "0vh",
            float: "left",
          }}
          className="trans"
        ></div>
        <div
          id="detailDiv"
          style={{ width: "0%", float: "left" }}
          className="trans"
        >
          <div className="MenuDetail">
            <Detail data={selectedItem != null ? selectedItem : []} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubMenu;
